import {
  USE_EDI_REQUEST,
  USE_EDI_SUCCESS,
  USE_EDI_FAILURE,
  USE_MAX_REQUEST,
  USE_MAX_SUCCESS,
  USE_MAX_FAILURE,
} from './types/DailyRouteLeadingCountUseEdiOrUseMaxActionsTypes';

export function postDailyRouteLeadingCountUseEdiRequestActionCreator(routeId, date) {
  return {
    type: USE_EDI_REQUEST,
    payload: {
      params: {
        assetRouteId: routeId,
        effectiveDate: date,
      },
    },
  };
}

export function postDailyRouteLeadingCountUseEdiSuccessActionCreator(data) {
  return {
    type: USE_EDI_SUCCESS,
    payload: data,
  };
}

export function postDailyRouteLeadingCountUseEdiFailureActionCreator(error) {
  return {
    type: USE_EDI_FAILURE,
    payload: error,
    error: true,
  };
}

export function postDailyRouteLeadingCountUseMaxRequestActionCreator(routeId, date) {
  return {
    type: USE_MAX_REQUEST,
    payload: {
      params: {
        assetRouteId: routeId,
        effectiveDate: date,
      },
    },
  };
}

export function postDailyRouteLeadingCountUseMaxSuccessActionCreator(data) {
  return {
    type: USE_MAX_SUCCESS,
    payload: data,
  };
}

export function postDailyRouteLeadingCountUseMaxFailureActionCreator(error) {
  return {
    type: USE_MAX_FAILURE,
    payload: error,
    error: true,
  };
}
